import React, { useState } from 'react';
import { FC } from 'react';
import useTranslations from '@hooks/useTranslation';
import ContentTemplate from '@ui/Content/Content';
import Title from '@ui/SectionTitle/Title';
import { getImageBaseURL } from '../../constants';
import { Background, Player, Video } from './Video.elements';

export interface VideoProps {}

const VideoTemplate: FC<VideoProps> = () => {
    const { t } = useTranslations();

    return (
        <Background>
            <ContentTemplate withPadding mobileSidePadding={20}>
                <Title isBlack>{t('subscription.video.title')}</Title>
                <Video>
                    <Player controls playsInline>
                        <source src="https://tv.epi.sk/__pp/_pv/video-pv-2024-lq.mp4" type="video/mp4" />
                    </Player>
                </Video>
            </ContentTemplate>
        </Background>
    );
};

export default VideoTemplate;
